/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useLayoutEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import swal from 'sweetalert';
import { PopupAlert } from '../components';
import { decrypt, handleClientData, handleInstalledApps, handleUserData } from '../Functions/authentication';
import axiosInstance from '../services/AxiosInstance';

export const userContext = createContext();

function AuthenticationContextProvider({ children }) {

    const history = useHistory();

    const [authenticated, setAuthenticated] = useState(() => localStorage.getItem('access') ? true : false);
    const [siteConfig, setSiteConfig] = useState({});
    const [user, setUser] = useState(() => {
        if (authenticated) {
            return decrypt(localStorage.getItem('user'), 'lsuser');
        } else return null;
    }); // eslint-disable-next-line
    const [reload, setReload] = useState('');
    const [commonData, setCommonData] = useState({
        "showPopupAlert": false
    });

    useLayoutEffect(() => {
        axiosInstance(
            '/client/', {
            method: 'GET',
            headers: {
                'Authorization': ''
            }
        }).then((res) => {
            setSiteConfig(res?.data?.results?.[0]);
            handleClientData(res?.data?.results?.[0]);
            document.title = res?.data?.results?.[0]?.name;
            const favicon = document.getElementById("favicon");
            favicon.setAttribute("href", res?.data?.results?.[0]?.logo);
        }).catch(err => console.log('err : ', err))
    }, [])

    const rollRedirection = (role) => {
        if (role === 4) history.push('/candidate')
        else if (role === 2 || role === 3) history.push('/employer')
        else history.push('/joc')
    }

    const loginUser = async (username, password) => {
        await axiosInstance('token/', { method: "POST", data: { username, password } })
            .then(response => {
                axiosInstance.defaults.headers['Authorization'] = "JWT " + response.data.access;
                if (response.status === 200) {
                    if (response?.data?.user?.red_listed) {
                        swal({
                            title: "You are not allowed to login",
                            text: "Please contact your Job office Coordinator",
                            icon: "warning",
                            button: "OK",
                        });
                    } else {
                        handleInstalledApps(response?.data?.access);
                        let userData = btoa(JSON.stringify({
                            id: response?.data?.user?.id,
                            otp: response?.data?.user?.emailOTP,
                            role: response?.data?.user?.role,
                            username: username,
                            password: password
                        }))
                        handleUserData(response?.data?.user, response?.data?.user?.pimg);
                        setUser(response?.data?.user);
                        if (response?.data?.user?.emailVerified) {
                            setAuthenticated(true);
                            rollRedirection(response?.data?.user?.role);
                        } else history.push(`/verify-otp/${userData}`)
                    }
                }
            }
            ).catch(error => { console.log('err : ', error, error.response); swal("", `${error?.response?.data?.detail}`, { button: "Try Again!" }) })
    }

    const getUserDetails = async () => {
        await axiosInstance('user/?me=yes', { method: "GET" })
            .then(response => {
                if (response.status === 200) {
                    let data = response?.data?.results?.[0];
                    handleUserData(data);
                    setUser(data);
                }
            }
            ).catch(error => { console.log('err : ', error, error.response); swal("", `${error?.response?.data?.detail}`, { button: "Try Again!" }) })
    }

    const showAlert = (title, onConfirm, showCancel, needCancel) => {
        setCommonData({
            ...commonData,
            showPopupAlert: true,
            title: title,
            onConfirm: onConfirm,
            showCancel: showCancel,
            needCancel: needCancel
        })
    }

    const contextData = {
        siteConfig,
        user,
        setUser,
        authenticated,
        setAuthenticated,
        setReload,
        commonData,
        showAlert,
        setCommonData,
        loginUser,
        rollRedirection,
        getUserDetails
    }

    return (
        <userContext.Provider value={contextData} >
            {children}
            <PopupAlert />
        </userContext.Provider>
    );
}

export default AuthenticationContextProvider;